var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_21459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.2055 0.000572192C31.3505 0.0138339 28.6242 0.25733 26.2253 0.681841C19.1585 1.93036 17.8754 4.54346 17.8754 9.36266V15.7273H34.5751V17.8488H11.608C6.75467 17.8488 2.50477 20.766 1.17559 26.3155C-0.357706 32.6765 -0.425655 36.646 1.17559 43.2879C2.36272 48.2318 5.19758 51.7545 10.051 51.7545H15.7927V44.1246C15.7927 38.6125 20.5619 33.7505 26.2253 33.7505H42.9057C47.5489 33.7505 51.2555 29.9275 51.2555 25.2644V9.36266C51.2555 4.837 47.4375 1.43721 42.9057 0.681841C40.0369 0.204283 37.0603 -0.0126895 34.2055 0.000572192ZM25.1742 5.11959C26.8992 5.11959 28.3078 6.55131 28.3078 8.31156C28.3078 10.0657 26.8992 11.4841 25.1742 11.4841C23.4431 11.4841 22.0406 10.0657 22.0406 8.31156C22.0406 6.55117 23.4431 5.11959 25.1742 5.11959Z",
    fill: "url(#paint0_linear_1930_21459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3378 17.8479V25.2636C53.3378 31.0128 48.4635 35.8517 42.9053 35.8517H26.225C21.656 35.8517 17.875 39.7622 17.875 44.3379V60.2396C17.875 64.7653 21.8104 67.4273 26.225 68.7257C31.5112 70.2801 36.5804 70.561 42.9053 68.7257C47.1096 67.5085 51.2551 65.0588 51.2551 60.2396V53.8749H34.5748V51.7533H59.6051C64.4585 51.7533 66.2671 48.368 67.955 43.2868C69.6986 38.0556 69.6244 33.0251 67.955 26.3144C66.7556 21.4827 64.4648 17.8477 59.6051 17.8477H53.3378V17.8479ZM43.9564 58.1181C45.6875 58.1181 47.09 59.5366 47.09 61.2907C47.09 63.0511 45.6875 64.4828 43.9564 64.4828C42.2314 64.4828 40.8228 63.0511 40.8228 61.2907C40.8227 59.5366 42.2313 58.1181 43.9564 58.1181Z",
    fill: "url(#paint1_linear_1930_21459)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1930_21459",
    x1: -1.63672,
    y1: 1.9907,
    x2: 36.8799,
    y2: 34.8373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A9FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#306998"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1930_21459",
    x1: 51.3715,
    y1: 55.2542,
    x2: 37.559,
    y2: 35.8841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD43B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE873"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_21459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.1dcb6e3ccd8ebe94b66552083d55e262.svg";
export { ForwardRef as ReactComponent };